module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_events_MouseEvent__;